import React, { useState } from 'react';
import { FileText, FolderOpen, Plus, Presentation } from 'lucide-react';
import ProjectFilesPanel from '../../ProjectFiles/ProjectFilesPanel';
import PresentationsList, { NewPresentationDialog } from '../../Presentations/PresentationsList';
import { reportApi } from '../../../services/presentationApi';
import { Card } from '../ui';
import ModelsCard from '../../Models/ModelsCard';

// Présentations et rapports client du projet (et ceux de son client et de son programme), puis le Drive du projet.
const NewButton = ({ label, onClick }) => (
  <button type="button" onClick={onClick}
    className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white hover:bg-slate-700">
    <Plus className="h-3.5 w-3.5" /> {label}
  </button>
);

const DocumentsTab = ({ projectId, project }) => {
  const [creating, setCreating] = useState(null);
  const scope = { type: 'project', id: projectId, label: project?.name || 'ce projet' };
  const backLabel = project?.name ? `Documents · ${project.name}` : 'Documents du projet';
  return (
    <div className="space-y-4">
      <Card title="Présentations" icon={Presentation} action={<NewButton label="Nouvelle présentation" onClick={() => setCreating('presentation')} />}>
        <PresentationsList backLabel={backLabel} params={{ scope_type: 'project', scope_id: projectId, related: true }}
          emptyText="Aucune présentation : « Nouvelle présentation », ou demandez-en une à Nexus." />
      </Card>
      <Card title="Rapports" icon={FileText} action={<NewButton label="Nouveau rapport" onClick={() => setCreating('report')} />}>
        <PresentationsList api={reportApi} path="/tools/rapports" backLabel={backLabel} params={{ scope_type: 'project', scope_id: projectId, related: true }}
          emptyText="Aucun rapport : « Nouveau rapport », ou demandez-en un à Nexus." />
      </Card>
      <ModelsCard projectId={projectId} />
      <ModelsCard projectId={projectId} pcb />
      <Card title="Fichiers du projet" icon={FolderOpen}>
        <ProjectFilesPanel projectId={projectId} project={project} maxHeight="70vh" />
      </Card>
      {creating === 'presentation' && <NewPresentationDialog scope={scope} backLabel={backLabel} onClose={() => setCreating(null)} />}
      {creating === 'report' && (
        <NewPresentationDialog scope={scope} api={reportApi} path="/tools/rapports" backLabel={backLabel} onClose={() => setCreating(null)} />
      )}
    </div>
  );
};

export default DocumentsTab;
